import { FormikForm } from '@festina-life/ui/formikForms'
import { JsTreeView } from '@festina-life/ui/listsAndTables'
import { useDataContext } from '@festina-life/ui/theme'

import type { CommandDataFormProps } from './CommandDataFormAndSimulation'
import type { AnyCommandVersion } from './types'

type CommandData = NonNullable<AnyCommandVersion['commandData']>

export const CommandModalDataFallbackForm = <T extends CommandData>(
  props: CommandDataFormProps<T>,
) => {
  const { data: commandData } = useDataContext<T>()

  return (
    <>
      {commandData && (
        <FormikForm {...props} initialValues={commandData}>
          <JsTreeView data={commandData} />
        </FormikForm>
      )}
    </>
  )
}
